import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickerGlobalIndexesComponent } from './ticker-global-indexes.component';

import { RouterModule } from '@angular/router';
import { SafePipe } from 'src/app/pipes/safe.pipe';



@NgModule({
  declarations: [
    TickerGlobalIndexesComponent
  ],
  imports: [
    CommonModule,
    SafePipe,
    RouterModule
    // RouterModule.forChild([{path:'',component:TickerGlobalIndexesComponent}])
  ],
  exports: [
    TickerGlobalIndexesComponent
  ],
})
export class TickerGlobalIndexesModule { }
